import React from "react";
import {
  ButtonText,
  FlexColumn,
  FlexRow,
  FormInputField,
  LargeButton,
  Text,
} from "../../../../../styles/Global";
import * as Global from "../../../../../styles/Global";
import StatBlock from "../../../../player/StatBlock";
import { Controller } from "react-hook-form";
import { RiLockPasswordFill } from "react-icons/ri";
import { AiFillInstagram } from "react-icons/ai";
import { BsFacebook } from "react-icons/bs";
import { connect, useSelector } from "react-redux";
import { setModal } from "../../../../../features/modals/modalSlice";
import { BiEdit } from "react-icons/bi";
import { MdOpenInNew } from "react-icons/md";
import { OpenExternalURL } from "../../../../../functions/helperFunctions";

const mapDispatch = {
  setModal,
};

const GodPowerCTA = ({ setModal, data }) => {
    console.log('GodPowerCTA data: ', data)
    const platform = useSelector((state) => state.organizer.platform);
  return (
    <FlexRow style={{ width: "100%" }} aligh="center" justify="space-around">
      <BiEdit
        color={Global.redLight}
        size={20}
        style={{ cursor: "pointer" }}
        onClick={() =>
          setModal(data.sport === 'DELETED' ? 
            {
              orgModals: {
                showModal: true, data: data, modalType: 52
              }
            }
            : {
            organizerCreateTournament: {
              showModal: true,
              data: {
                clone: false,
                isEdit: true,
                gameid: data.gameid,
                godPowerAccountId: data.accountid,
              },
            },
          })
        }
      />
      <MdOpenInNew
        color={Global.redLight}
        size={20}
        style={{ cursor: "pointer" }}
        onClick={() =>
          OpenExternalURL(data.adminlink, platform)
        }
      />
    </FlexRow>
  );
}


export default connect(null, mapDispatch)(GodPowerCTA);